import {omitNull} from 'common/utils';


export default class ServiceGeometries {
  constructor({
                dropoff,
                pickup,
              }) {
    this.dropoff = dropoff || null;
    this.pickup = pickup || null;
  }

  clone() {
    return new ServiceGeometries(this.serialize());
  }

  serialize() {
    return omitNull({
      dropoff: this.dropoff,
      pickup: this.pickup,
    });
  }
}



// WEBPACK FOOTER //
// ./src/ondemand/types/ServiceGeometries.js